import RtkQueryService from '@lok/services/RtkQueryService';

import { transformErrorResponse } from '../api';

const boardService = RtkQueryService.injectEndpoints({
  endpoints: (builder) => ({
    fetchBoards: builder.query({
      query: () => ({
        url: '/v1/boards/',
        params: {
          fields: 'id,slug,title,updated_at,unread_count'
        }
      }),
      providesTags: ['BoardUnread'],
      transformErrorResponse
    }),
    fetchBoardByCourse: builder.query({
      query: (courseId) => ({
        url: '/v1/boards/',
        params: {
          course: courseId,
          fields: 'id,slug,title,updated_at,unread_count'
        }
      }),
      providesTags: ['BoardUnread'],
      transformErrorResponse
    }),
    fetchBoardByModule: builder.query({
      query: (moduleId) => ({
        url: '/v1/boards/',
        params: {
          module: moduleId,
          fields: 'id,slug,title,updated_at,unread_count'
        }
      }),
      providesTags: ['BoardUnread'],
      transformErrorResponse
    }),
    fetchBoardByLesson: builder.query({
      query: (lessonId) => ({
        url: '/v1/boards/',
        params: {
          lesson: lessonId,
          fields: 'id,slug,title,updated_at,unread_count'
        }
      }),
      providesTags: ['BoardUnread'],
      transformErrorResponse
    }),
    fetchTotalUnread: builder.query({
      query: () => ({
        url: '/v1/boards/total-unread/'
      }),
      providesTags: ['UnreadTotal'],
      transformErrorResponse
    }),
    fetchUnreadDetails: builder.query({
      query: ({ limit = 10, includeRead = false } = {}) => ({
        url: '/v1/boards/unread-details/',
        params: includeRead
          ? { limit, include_read: 'true' }
          : { limit }
      }),
      providesTags: ['BoardUnread'],
      transformErrorResponse
    }),
    markAllThreadsRead: builder.mutation({
      query: () => ({
        url: '/v1/boards/mark-all-read/',
        method: 'POST'
      }),
      invalidatesTags: ['UnreadTotal', 'BoardUnread'],
      transformErrorResponse
    }),
    createBoard: builder.mutation({
      query: (data) => ({
        url: '/v1/boards/',
        method: 'POST',
        data
      }),
      transformErrorResponse
    })
  })
});

export const {
  useFetchBoardsQuery,
  useFetchBoardByCourseQuery,
  useFetchBoardByModuleQuery,
  useFetchBoardByLessonQuery,
  useFetchTotalUnreadQuery,
  useFetchUnreadDetailsQuery,
  useMarkAllThreadsReadMutation,
  useCreateBoardMutation
} = boardService;
